import { forwardRef } from "react";

import { Form } from "@shared/components/Form";
import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getPartnersService } from "@modules/partners/services/queries/listPartners/service";

export const PartnersAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete
      {...props}
      ref={ref}
      labelField="name"
      queryHook={getPartnersService}
    />
  );
});

PartnersAutocomplete.displayName = "PartnersAutocomplete";
